import {extendObservable} from 'mobx';
import * as vgAuth from '../vgAuth';


/**
 * UserStore
 */
class UserStore {
    constructor() {
        extendObservable(this, {
            loading: false,
            isLoggedIn: false,
            user_id: '',
            username: '',
            email: '',
            customer: null,
            access_token: '',
            refresh_token: null,
            roles: [],
            picture: '/global_assets/images/image.png',
            services: []
        });
    }

    // ----- actions / helpers -----

    setTokens({ accessToken, refreshToken }) {
        this.access_token = accessToken || '';
        this.refresh_token = typeof refreshToken !== 'undefined' ? refreshToken : null;
        this.isLoggedIn = !!this.access_token;
    }

    setProfileFromMe(me) {
        me = me || {};
        this.user_id  = me.id || '';
        this.email    = me.email || '';
        this.username = me.username || this.email || '';
        this.customer = me.customer || null;

        const roleStrings = Array.isArray(me.roles) ? me.roles : [];
        this.roles = roleStrings.map(r => ({ authority: r }));
    }

    saveToSession() {
        const payload = {
            refresh_token: this.refresh_token,
            access_token: this.access_token,
            username: this.username,
            isLoggedIn: this.isLoggedIn,
            roles: this.roles,
            loading: this.loading,
            picture: this.picture
        };
        sessionStorage.setItem('loginSession', JSON.stringify(payload));
    }

    loadFromSession() {
        try {
            const raw = sessionStorage.getItem('loginSession');
            if (!raw) return;
            const s = JSON.parse(raw);

            this.refresh_token = (s && typeof s.refresh_token !== 'undefined') ? s.refresh_token : null;
            this.access_token  = (s && s.access_token) || '';
            this.username      = (s && s.username) || '';
            this.isLoggedIn    = !!(s && s.isLoggedIn) && !!this.access_token;
            this.roles         = (s && Array.isArray(s.roles)) ? s.roles : [];
            this.loading       = !!(s && s.loading);
            this.picture       = (s && s.picture) || this.picture;
        } catch (e) {
        }
    }

    clear() {
        this.loading       = false;
        this.isLoggedIn    = false;
        this.user_id       = '';
        this.username      = '';
        this.email         = '';
        this.customer      = null;
        this.access_token  = '';
        this.refresh_token = null;
        this.roles         = [];
        this.services      = [];
        sessionStorage.removeItem('loginSession');
        vgAuth.logout();
    }

    async login(username, password) {
        this.loading = true;
        try {
            const tokenData = await vgAuth.login(username, password);
            this.setTokens({
                accessToken: tokenData.access_token,
                refreshToken: tokenData.refresh_token
            });
            this.saveToSession();
            return tokenData;
        } catch (error) {
            this.loading = false;
            throw error;
        }
    }

    async getAccessToken() {
        try {
            return await vgAuth.getAccessToken();
        } catch (error) {
            this.clear();
            throw error;
        }
    }


    hasRole(name) {
        return Array.isArray(this.roles) && this.roles.some(r => r.authority === name);
    }

    hasAnyRole(names) {
        names = names || [];
        if (!Array.isArray(this.roles)) return false;
        return this.roles.some(r => names.indexOf(r.authority) !== -1);
    }

    hasAllRoles(names) {
        names = names || [];
        if (!Array.isArray(this.roles)) return false;
        return names.every(n => this.roles.some(r => r.authority === n));
    }
}

export default new UserStore();
